import { z } from "zod";

export const CreateMessageSchema = z.object({
  modelId: z.number().int().positive(),
  content: z.string().min(1)
});

// For multipart/form-data requests (modelId comes as string)
export const CreateMessageWithFilesSchema = z.object({
  modelId: z.coerce.number().int().positive(),
  content: z.string().min(1)
});

// File validation constants
export const ALLOWED_FILE_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
] as const;
// OpenAI Responses API input_file: max 50MB per file, 50MB combined per request
export const MAX_FILE_SIZE = 50 * 1024 * 1024;
export const MAX_TOTAL_FILES_SIZE = 50 * 1024 * 1024;
export const MAX_FILES_PER_MESSAGE = 20;

export type CreateMessageInput = z.infer<typeof CreateMessageSchema>;
export type CreateMessageWithFilesInput = z.infer<
  typeof CreateMessageWithFilesSchema
>;
